import axios from "axios";
import { clientEnv } from "../config/env";

const axiosInstance = axios.create({
    baseURL: clientEnv.apiBaseUrl,
    //baseURL: "/api/api",
    timeout: 60000,
    headers: { "Content-Type": "application/json" },
});

export default axiosInstance;
